










































# import settings from '@/settings'
import n from '@/utils/notifications'
import t from '@/utils/tools'
import q from '@/graphql/query'
import m from '@/graphql/mutation'

export default {
    name: 'company_establishments'

    data: ()->
        loading: true
        alert: false
        search: ''
        pager_count: 5
        current_page: 1
        page_size: 10
        establishments: []

    computed:
        data_filtered: ()->
            self = @
            data = @establishments.filter (x) ->
                !self.search || x.name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase()) || x.name.toLowerCase().includes(self.search.toLowerCase())\
                || x.siret.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase()) || x.siret.toLowerCase().includes(self.search.toLowerCase())\
                || x.address.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase()) || x.address.toLowerCase().includes(self.search.toLowerCase())\
                || x.address2.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase()) || x.address2.toLowerCase().includes(self.search.toLowerCase())\
                || x.zipcode.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase()) || x.zipcode.toLowerCase().includes(self.search.toLowerCase())\
                || x.city.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase()) || x.city.toLowerCase().includes(self.search.toLowerCase())\
                || x.phone.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase()) || x.phone.toLowerCase().includes(self.search.toLowerCase())\
                || x.email.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase()) || x.email.toLowerCase().includes(self.search.toLowerCase())
            return data

        data_paged: ()->
            data = @data_filtered.slice(((@current_page - 1) * @page_size), (@page_size * @current_page))
            return data

        has_mutation_right: ()->
            return @has_access_right('establishments_edit')

        has_deletion_right: ()->
            return @has_access_right('establishments_delete')

    methods:
        has_access_right: t.has_access_right

        listen_sort: ({ column, prop, order })->
            # console.log "LISTEN", column, prop, order
            self = @
            @establishments.sort (a,b)->
                modifier = 1
                if order == 'descending'
                    modifier = -1
                return a[prop].toLowerCase().localeCompare(b[prop].toLowerCase())*modifier
            # @establishments.sort (a,b)->
            #     modifier = 1
            #     if order == 'descending'
            #         modifier = -1
            #     if a[prop].toLowerCase() < b[prop].toLowerCase()
            #         return -1 * modifier
            #     if a[prop].toLowerCase() > b[prop].toLowerCase()
            #         return 1 * modifier
            #     return 0
            # console.log "ESTABLISHMENTS SORT ", @establishments

        handle_size_change: (val)->
            @page_size = val

        handle_current_change: (val)->
            @current_page = val

        get_establishments: ()->
            self = @
            @loading = true
            q.run('get_establishment_set', [@$store.getters.current_company.uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("company_establishments: get_establishments: then", e.message)
                else
                    # console.log "GET ESTABLISHMENTS : ", resp.body.data.establishment_set
                    self.establishments = resp.body.data.establishment_set
                    self.loading = false
                    if self.establishments.length == 0
                        self.alert = true
                    else
                        self.alert = false
            .catch (resp)->
                n.catch_error(resp, "company_establishments: get_establishments()")

        delete_establishment: (establishment_uid)->
            self = @
            @$confirm("Êtes-vous sûr·e de vouloir supprimer cet établissement ?", 'Confirmation', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler'
                })
                .then ()->
                    m.run('delete_object', ['establishment', establishment_uid])
                    .then (resp)->
                        if resp.body.data.establishment_deletion.ok
                            n.success()
                            self.get_establishments()
                        else
                            n.gql_error("company_establishments: delete_establishment: then", resp.body.data.establishment_deletion.message)
                    .catch (resp)->
                        n.catch_error(resp, "company_establishments: delete_establishment()")
                .catch (cancel)->
                    return
    beforeMount: ()->
        @get_establishments()
}

